(function () {
	
	const announcement = () => {
		const swiperWrap = document.querySelector('.c-announce__swiper');
		let swiper
        
        swiper = new Swiper(swiperWrap, {
            slidesPerView : 1,
            navigation: {
                prevEl: '.c-announce__left',
                nextEl: '.c-announce__right',
            },
            autoplay: {
                delay: 3000,
            },
            loop: true,

        })

        const stopSwiper = () => {
            swiper.autoplay.stop();
        }
        const startSwiper = () => {
            swiper.autoplay.start();
        }
        swiperWrap.addEventListener('mouseover', stopSwiper)
        swiperWrap.addEventListener('mouseout', startSwiper)
	}

	document.addEventListener('shopify:section:load', announcement);
	announcement();

})();